import { createContext } from 'react';

import { OrderViewProps } from 'types';

export const OrderContext = createContext<OrderViewProps | null>(null);
